import { render, staticRenderFns } from "./footTM.vue?vue&type=template&id=250a6dbf&scoped=true&"
import script from "./footTM.vue?vue&type=script&lang=js&"
export * from "./footTM.vue?vue&type=script&lang=js&"
import style0 from "./footTM.vue?vue&type=style&index=0&id=250a6dbf&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250a6dbf",
  null
  
)

export default component.exports